<template>
  <div class="page_eleApplication">
    <div class="eleTltle">查看明细</div>
    <!-- <div class="eleForm"> -->
      <div class="eleForm" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-distance="20" style="overflow:auto">
        <div class="dtlItem" v-for="(item,index) in detailTable" :key="index">
          <div class="flex sb">
            <div class="name">{{ item.MainlinsuredName }}</div>
            <div class="phone">{{ item.MainlinsuredPhone }}</div>
          </div>
          <div class="insType">{{ item.InsuranceName }}</div>
          <div class="insType">证件号码:{{item.MainlinsuredCardId}}</div>
          <div class="infoBox flex" style="margin-top: 5px;">
            <div class="info_item">项目名称:{{item.ProjectName}}</div>
            <div class="info_item">岗位:{{item.JobName}}</div>
            <div class="info_item">职业类别:{{item.JobClasss}}</div>

            <div class="info_item">员工属性:{{item.EmployeeAttribute}}</div>
            <div class="info_item">保障开始:{{item.InsuranceStartTime}}</div>
            <div class="info_item">保障结束:{{item.InsuranceEndTime}}</div>
          </div>
          <div class="info_item" style="width:100%">劳动合同公司:{{item.LaborContractUnit}}</div>
        </div>
      <!-- </div> -->
      <p v-if="loading">加载中...</p>
      <p v-if="noMore && detailTable.length>0" style="text-align: center;">没有更多了</p>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  export default {
    data() {
      return {
        detailTable: [],
        detTotal: 0,
        loading: false,
        roletype: localStorage.loginRoletype,
        listQuery: {
          Id: '',
          MainlinsuredCardId: '', //身份证号码
          ServiceProviderStatu: '', //保司失败参数
          pageNum: 1,
          pageSize: 10
        },
      };
    },
    async created() {
      this.$store.commit("setHiddenLeft", true);
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.listQuery.Id = this.$route.query.id;
        this.getList();
      }
    },
    computed: {
      noMore() {
        return this.detailTable.length >= this.detTotal
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
    methods: {
      getList() {
        this.loading = true;
        xz.insuranceH5(this.listQuery).then(res => {
          console.log(res)
          if (res.status == 'ok') {
            this.detailTable = res.data.ret;
            this.detTotal = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            this.detailTable = [];
            this.detTotal = 0;
            this.$toast.fail(res.msg);
          }
        })
      },
      load() {
        console.log('load')
        this.loading = true;
        this.listQuery.pageNum = this.listQuery.pageNum + 1;
        xz.insuranceH5(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detailTable.push(...res.data.ret);
            this.detTotal = res.data.totalCount;
            this.loading = false;
          } else {
            this.$toast.fail(res.msg);
            this.loading = false;
          }
        })
      },
    },
  };
</script>
<style scoped>
  .page_eleApplication {
    background: #fff;
    /* min-height: 100vh; */
  }

  .eleTltle {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #fff;
    text-align: center;
  }

  .eleForm {
    padding: 20px 12px;
    background: #F4F3F9;
    /* min-height: calc(100vh - 100px); */
    max-height: 900px;
    /* padding-bottom: 50px; */
  }

  .dtlItem {
    background-color: #fff;
    box-shadow: 0px 4px 6px 0px rgba(104, 11, 255, 0.02);
    border-radius: 10px;
    padding: 10px 12px 20px;
    margin-bottom: 12px;
  }

  .name {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
  }

  .phone {
    font-family: PingFangSC-;
    font-size: 32rpx;
    color: #4BC266;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
  }

  .insType {
    font-size: 14px;
    color: #333333;
    margin-top: 5px;
  }

  .infoBox {
    flex-wrap: wrap
  }

  .info_item {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    margin-bottom: 5px;
    width: 49%;
  }
</style>
<style>
  .page_eleApplication .van-icon-photograph:before {
    font-size: 26px;
  }
</style>